module.exports = __webpack_public_path__ + "img/festival_easter.06cc9c68.png";